import React from 'react';
import { Link } from "react-router-dom";

import HomeImage from '../Images/HomeImage.jpg';
import { FaCheckCircle,FaDesktop,FaArrowRight,FaSuitcase} from 'react-icons/fa';

const services = [
  {
    "title": "IT Strategic Planning",
    "description": "Craft customized IT strategies that align technology with your business goals, driving measurable success.",
    "features": [
      "IT roadmap development.",
      "Cost and operational efficiency optimization.",
      "Integration of emerging technologies for competitiveness.",
      "Scalable IT infrastructure to meet future demands."
    ],
    "why": "DeepCyber Consulting combines strategic insights with actionable plans to help your business thrive in the digital age."
  },
  {
    "title": "IT Augmentation",
    "description": "Expand your IT team with certified professionals for projects of any size or duration.",
    "features": [
      "Certified experts for temporary or long-term roles.",
      "Rapid deployment for critical projects.",
      "Tailored solutions to fill skill gaps and scale operations."
    ],
    "why": "Our experts integrate seamlessly with your team, delivering immediate value."
  },
  {
    "title": "Software Development",
    "description": "Streamline your workflows with custom software solutions tailored to your unique needs.",
    "features": [
      "Full-stack development for web, mobile, and cloud platforms.",
      "Seamless integration with existing tools.",
      "Agile delivery for flexibility and timely deployment.",
      "Post-deployment support for updates and scalability."
    ],
    "why": "We deliver innovative, user-centric solutions that drive productivity."
  },
  {
    "title": "IT Helpdesk Support",
    "description": "Reliable 24/7 IT support to minimize downtime and maximize productivity.",
    "features": [
      "Round-the-clock troubleshooting and resolution.",
      "Remote and on-site support tailored to your needs.",
      "Easy-to-use ticketing system for seamless tracking."
    ],
    "why": "We provide fast, efficient, and customer-focused IT support."
  },
  {
    "title": "Firewall Management",
    "description": "Shield your network from evolving threats with our expert firewall solutions.",
    "features": [
      "Configuration and rule optimization for peak performance.",
      "Real-time threat detection and response.",
      "Regular updates to maintain robust security."
    ],
    "why": "Our proactive firewall management keeps your network secure and compliant."
  },
  {
    "title": "IT Asset/Patch Management",
    "description": "Ensure your IT environment operates securely and efficiently.",
    "features": [
      "Automated tracking of IT assets.",
      "Regular updates to maintain robust security."
    ],
    "why": "DeepCyber Consulting ensures your systems are always up-to-date and protected."
  },
  {
    "title": "Endpoint Detection and Response (EDR) Service",
    "description": "Comprehensive endpoint security to detect, investigate, and respond to threats.",
    "features": [
      "Threat hunting and real-time analytics.",
      "Automated response and remediation.",
      "Multi-platform coverage (Windows, Mac, Linux).",
      "Detailed incident reports for better security posture."
    ],
    "why": "We safeguard your endpoints with cutting-edge tools and expertise."
  },
  {
    "title": "Vulnerability Management",
    "description": "Identify and remediate security gaps to fortify your defenses.",
    "features": [
      "Comprehensive scanning for networks, applications, and devices.",
      "Risk-based prioritization to address critical vulnerabilities.",
      "Detailed remediation guidance."
    ],
    "why": "Our systematic approach enhances your security posture and ensures compliance."
  },
  {
    "title": "End User Awareness Training",
    "description": "Transform your team into a first line of defense against cyber threats.",
    "features": [
      "Real-world phishing simulations.",
      "Interactive training modules.",
      "Progress tracking and reporting.",
      "Industry-specific workshops."
    ],
    "why": "We empower your employees with the knowledge to prevent cyber incidents."
  },
  {
    "title": "Security & Risk Assessment",
    "description": "Comprehensive evaluations to uncover and mitigate risks.",
    "features": [
      "IT audits to identify gaps and inefficiencies.",
      "Risk assessments for critical assets.",
      "Compliance checks with regulations like GDPR and PCI-DSS.",
      "Tailored security roadmaps for enhanced defense."
    ],
    "why": "Our in-depth assessments deliver actionable insights for a secure IT landscape."
  }
];

export default function ServiceTemp() {
  return (
    <div className="service-page bg-light">
      {/* Hero Section - Properly Responsive */}
      <section className="py-5">
        <div className="container">
          <div className="row align-items-center g-4">
            {/* Image Column - Same height as cards */}
            <div className="col-12 col-md-6">
              <div className="hero-image-container">
                <img 
                  src={HomeImage} 
                  alt="Goal" 
                  className="img-fluid rounded-3 shadow-lg w-100" 
                  style={{ 
                    height: '350px',
                    objectFit: 'cover'
                  }} 
                />
              </div>
            </div>

            {/* Text Content Column - Matching card height */}
            <div className="col-12 col-md-6">
              <div className="hero-content h-100 d-flex flex-column justify-content-center">
                <h2 className="hero-title fw-bold text-dark mb-3" style={{ fontFamily: 'Garmond' }}>
                  Secure, Optimize, and Transform Your IT Environment with DeepCyber Consulting
                </h2>
                <p className="hero-subtitle text-muted mb-4">
                  Empowering businesses with innovative IT solutions and proactive cybersecurity services to stay ahead in the digital era.
                </p>
                
                {/* Responsive Button Container */}
                <div className="hero-buttons d-flex gap-3">
                  <Link to='/contact' className='text-decoration-none'>
                  <button className="btn-custom btn-responsive d-flex align-items-center justify-content-center rounded-5">
                    <FaArrowRight className="btn-icon me-2" /> 
                    <span className="btn-text">Get Started</span>
                  </button>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Services Section */}
      <div className="container py-5 border-top ">
        <h2 className="text-center fw-bold mb-5 text-navyblue">
         <FaSuitcase className="me-2 mb-2" /> Our Services
        </h2>
        <div className="row g-4 text-start">
          {services.map((service, index) => (
            <div className="col-12 col-md-6" key={index}>
              <div className="card h-100 shadow-lg border-0 rounded-4 service-card" style={{ minHeight: '350px' }}>
                <div className="card-body d-flex flex-column p-4">
                  <h4 className="fw-bold text-navyblue mb-3">{service.title}</h4>
                  <hr />
                  <p className="text-muted">{service.description}</p>

                  <h6 className="fw-bold mt-3">Key Features:</h6>
                  <ul className="list-unstyled">
                    {service.features.map((feature, i) => (
                      <li key={i} className="d-flex align-items-start mb-2">
                        <FaCheckCircle className="text-navyblue me-2 mt-1 flex-shrink-0" />
                        <span>{feature}</span>
                      </li>
                    ))}
                  </ul>

                  <div className="mt-auto pt-3 border-top">
                    <h6 className="fw-bold text-dark">Why Choose Us?</h6>
                    <p className="mb-0 text-secondary">{service.why}</p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}